import { defineStore } from "pinia";

import { listUserMenus } from "@/api/menu";
export interface MenuItem {
  id: number;
  parentId: number;
  children: MenuItem[];
  hasChildren: boolean;
  icon: string;
  name: string;
  spread: boolean;
  path: string;
  keepAlive: string;
  permission?: any;
  type: string;
  label: string;
  sort: number;
}
const BASE_PREFIX = "/m_op";
const flatMenu = (arr: MenuItem[]) => {
  const res = [] as MenuItem[];
  const getRouter = (items: MenuItem[]) => {
    items.forEach((item) => {
      if (item.path !== BASE_PREFIX) {
        res.push(item);
      }
      if (item.children?.length) {
        getRouter(item.children);
      }
    });
  };
  getRouter(arr);
  return res;
};

const default_menu = JSON.parse(
  window.sessionStorage.getItem("menu_data") || "[]"
);

export const useMenuStore = defineStore({
  id: "menu", // id必填，且需要唯一
  state: () => {
    return {
      menuList: default_menu as MenuItem[],
      menuFlat: flatMenu(default_menu) as MenuItem[],
    };
  },
  actions: {
    initMenu() {
      return listUserMenus().then((res) => {
        this.setList(res.data);
      });
    },
    setList(list: MenuItem[]) {
      this.menuList = list;
      this.menuFlat = flatMenu(list);
    },
  },
});
